<template>
  <v-app-bar app dark flat>
    <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
    {{ title }}
    <v-spacer />
    <slot />
  </v-app-bar>
</template>

<script>
import { sync } from 'vuex-pathify'

export default {
  name: 'AppBar',

  props: {
    title: String
  },

  computed: {
    drawer: sync('app/drawer')
  }
}
</script>
